"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveOverridesToLocalStorage = exports.loadOverridesFromLocalStorage = exports.makeEmptyOverrides = exports.STORAGE_KEY = void 0;
var StatsigLocalStorage_1 = __importDefault(require("./utils/StatsigLocalStorage"));
exports.STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
function makeEmptyOverrides() {
    return { gates: {}, configs: {}, layers: {} };
}
exports.makeEmptyOverrides = makeEmptyOverrides;
function loadOverridesFromLocalStorage() {
    var raw = StatsigLocalStorage_1.default.getItem(exports.STORAGE_KEY);
    if (raw) {
        try {
            return JSON.parse(raw);
        }
        catch (error) {
            // noop
        }
    }
    return makeEmptyOverrides();
}
exports.loadOverridesFromLocalStorage = loadOverridesFromLocalStorage;
function saveOverridesToLocalStorage(overrides) {
    StatsigLocalStorage_1.default.setItem(exports.STORAGE_KEY, JSON.stringify(overrides));
}
exports.saveOverridesToLocalStorage = saveOverridesToLocalStorage;
